class FeaturedCollectionSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.product-grid');
    if (!this.slider) {
      return;
    }

    // Respect admin "Swipe on mobile" setting (data-mobile-slider="false" disables the slider)
    this.mobileSliderEnabled = this.dataset.mobileSlider !== 'false';
    if (!this.mobileSliderEnabled) return;
    
    this.slides = this.slider.querySelectorAll('.flex-grid__item');
    this.currentIndex = 0;
    this.isMobile = window.innerWidth <= 989;

    if (this.isMobile && this.slides.length > 1) {
      this.init();
    }

    window.addEventListener('resize', () => {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth <= 989;
      
      if (this.isMobile && !wasMobile && this.slides.length > 1) {
        this.init();
      } else if (!this.isMobile && wasMobile) {
        this.destroy();
      }
    });
  }

  init() {
    this.createDots();
    this.slider.scrollLeft = 0;
    this.currentIndex = 0;
    // Do NOT call updateSlide() here — it triggers scrollIntoView() which
    // causes the browser to scroll the viewport vertically to this section
    // on page load and back-navigation (especially on mobile/tablet where
    // content-visibility layout shifts are in play). The first slide is
    // already at scrollLeft=0 and createDots() already marks dot[0] active.
    this.addSwipeListeners();
  }

  destroy() {
    const dotsContainer = this.querySelector('.featured-collection-dots');
    if (dotsContainer) {
      dotsContainer.remove();
    }
    this.slider.scrollLeft = 0;
  }

  createDots() {
    if (this.querySelector('.featured-collection-dots')) return;

    const dotsContainer = document.createElement('div');
    dotsContainer.className = 'featured-collection-dots';

    this.slides.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.className = 'featured-collection-dot';
      dot.setAttribute('aria-label', `Go to slide ${index + 1}`);
      if (index === 0) dot.classList.add('active');
      
      dot.addEventListener('click', () => {
        this.goToSlide(index);
      });
      
      dotsContainer.appendChild(dot);
    });

    this.appendChild(dotsContainer);
  }

  updateSlide() {
    if (!this.isMobile) return;

    // scrollIntoView is reliable with CSS scroll-snap (avoids scroll-snap-stop: always blocking scrollTo)
    const targetSlide = this.slides[this.currentIndex];
    if (targetSlide) {
      targetSlide.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'start'
      });
    }

    // Update dots
    const dots = this.querySelectorAll('.featured-collection-dot');
    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === this.currentIndex);
    });
  }

  goToSlide(index) {
    this.currentIndex = index;
    this.updateSlide();
  }

  addSwipeListeners() {
    let startX = 0;
    let scrollLeft = 0;

    this.slider.addEventListener('touchstart', (e) => {
      startX = e.touches[0].pageX;
      scrollLeft = this.slider.scrollLeft;
    });

    this.slider.addEventListener('touchend', (e) => {
      const endX = e.changedTouches[0].pageX;
      const diff = startX - endX;

      if (Math.abs(diff) > 50) {
        if (diff > 0 && this.currentIndex < this.slides.length - 1) {
          this.currentIndex++;
        } else if (diff < 0 && this.currentIndex > 0) {
          this.currentIndex--;
        }
        this.updateSlide();
      }
    });

    // Update current slide on scroll end
    let scrollTimeout;
    this.slider.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const slideWidth = this.slides[0] ? this.slides[0].offsetWidth : window.innerWidth;
        const newIndex = Math.round(this.slider.scrollLeft / slideWidth);
        
        if (newIndex !== this.currentIndex && newIndex >= 0 && newIndex < this.slides.length) {
          this.currentIndex = newIndex;
          const dots = this.querySelectorAll('.featured-collection-dot');
          dots.forEach((dot, index) => {
            dot.classList.toggle('active', index === this.currentIndex);
          });
        }
      }, 100);
    });
  }
}

customElements.define('featured-collection-slider', FeaturedCollectionSlider);
